import React, { FC } from 'react';
import {
  DailyProfitCard,
  KeyMetricsLayout,
  ProfitTargetCard,
  UnrealizedProfitCard,
  WeeklyProfitCard,
} from './components';

export const KeyMetrics: FC = () => {
  return (
    <KeyMetricsLayout>
      <DailyProfitCard />
      <UnrealizedProfitCard />
      <WeeklyProfitCard />
      <ProfitTargetCard />
    </KeyMetricsLayout>
  );
};
